export const colors = {
  gray: "#AFAFAF",
  darkGray: "#858585",
  lightGray: "#E8E8E8",
  black: "#000000",
  white: "#FFFFFF",
  pink: "#FF5B27",
};
